"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var build_url_1 = __importDefault(require("build-url"));
/**
 * A class that can build up a URL for a JSON API Endpoint.
 * This object is designed to be passed around and used by Managers.
 */
var APIUrlBuilder = /** @class */ (function () {
    function APIUrlBuilder(url) {
        if (url === void 0) { url = null; }
        this.url = "";
        this.offset = null;
        this.limit = null;
        this.sort = [];
        this.filters = {};
        this.params = {};
        this.includes = [];
        if (url !== null) {
            this.url = url;
        }
    }
    /**
     * Add a new filter property
     * @param {String} field
     * @param {*} value
     */
    APIUrlBuilder.prototype.addFilter = function (field, value) {
        if (value === true) {
            value = "1";
        }
        else if (value === false) {
            value = "0";
        }
        this.filters[field] = value;
    };
    /**
     * Clears all sorting options and starts a new one.
     * @param {String} fieldName the name of the field to sort on
     * @param {Boolean} isAscending Sort will be ascending (False for descending).
     */
    APIUrlBuilder.prototype.setSort = function (fieldName, isAscending) {
        if (isAscending === void 0) { isAscending = true; }
        this.sort = [{ field: fieldName, asc: isAscending }];
    };
    /**
     * Add a sorting option
     * @param {String} fieldName the name of the field to sort on
     * @param {Boolean} isAscending Sort will be ascending (False for descending).
     */
    APIUrlBuilder.prototype.addSort = function (fieldName, isAscending) {
        if (isAscending === void 0) { isAscending = true; }
        this.sort.push({ field: fieldName, asc: isAscending });
    };
    /**
     * Add an include relationship field.
     * @param {...String}
     */
    APIUrlBuilder.prototype.addInclude = function () {
        if (arguments.length > 0) {
            for (var i = 0; i < arguments.length; i++) {
                if (arguments.hasOwnProperty(i)) {
                    this.includes.push(arguments[i]);
                }
            }
        }
    };
    /**
     * Set the pagination offset.
     * @param {Number} limit
     * @param {Number} offset
     */
    APIUrlBuilder.prototype.setPagination = function (limit, offset) {
        if (offset === void 0) { offset = 0; }
        this.limit = limit;
        this.offset = offset;
    };
    /**
     * Adds arbitrary query params.
     * @param {String} key
     * @param {*} value
     */
    APIUrlBuilder.prototype.addQueryParam = function (key, value) {
        this.params[key] = value;
    };
    /**
     * Sets or replaces the URL
     * @param {String} url
     */
    APIUrlBuilder.prototype.setUrl = function (url) {
        this.url = url;
    };
    /**
     * Build the URL based on all the data provided.
     * @returns {String} the URL of the request.
     */
    APIUrlBuilder.prototype.generate = function (options) {
        if (options === void 0) { options = {}; }
        options = {
            excludePagination: options.excludePagination || false
        };
        /*
         * Build up the base params array
         */
        var params = {};
        for (var i in this.params) {
            if (this.params.hasOwnProperty(i)) {
                params[i] = this.params[i];
            }
        }
        /* Pagination */
        if (!options.excludePagination) {
            if (this.limit !== null) {
                params["page[limit]"] = this.limit.toString();
                if (this.offset !== null) {
                    params["page[offset]"] = this.offset.toString();
                }
            }
        }
        /* Filters */
        if (this.filters !== {}) {
            for (var i in this.filters) {
                if (this.filters.hasOwnProperty(i)) {
                    params["filters[" + i + "]"] = this.filters[i];
                }
            }
        }
        /* Sorting */
        if (this.sort.length > 0) {
            var sortFormatted = [];
            for (var i in this.sort) {
                if (this.sort.hasOwnProperty(i)) {
                    if (this.sort[i].asc) {
                        sortFormatted.push(this.sort[i].field);
                    }
                    else {
                        sortFormatted.push("-" + this.sort[i].field);
                    }
                }
            }
            params["sort"] = sortFormatted.join(",");
        }
        /* Includes */
        if (this.includes.length > 0) {
            params["include"] = this.includes.join(",");
        }
        for (var i in params) {
            if (params.hasOwnProperty(i)) {
                params[i].toString();
            }
        }
        return build_url_1.default(this.url, {
            queryParams: params
        });
    };
    /**
     * Create a generic toString method that returns the generated string.
     * @returns {String}
     */
    APIUrlBuilder.prototype.toString = function () {
        return this.generate();
    };
    return APIUrlBuilder;
}());
exports.default = APIUrlBuilder;
//# sourceMappingURL=data:application/json;base64,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